import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useSearchContext } from './SearchContextProvider.js';

var usePopularSearches = function usePopularSearches(locale) {
  var _React$useState = React__default.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    popularSearches = _React$useState2[0],
    setPopularSearches = _React$useState2[1];
  var _React$useState3 = React__default.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isPopularSearchesLoaded = _React$useState4[0],
    setIsPopularSearchesLoaded = _React$useState4[1];
  var _useSearchContext = useSearchContext(),
    logger = _useSearchContext.logger;
  var FAILED_TO_FETCH_POPULAR_SEARCHES = 'Failed to fetch popular searches';
  var INVALID_DATA_FORMAT = 'Invalid data format for popular searches:';
  function logWarning(message, context) {
    if (!logger) {
      console.warn(message, context);
      return;
    }
    try {
      logger.warning(message, context);
    } catch (error) {
      console.warn('Error logging warning:', error);
    }
  }
  useEffect(function () {
    var fetchPopularSearches = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(locale) {
        var response, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("https://manual-popular-searches.productdiscovery.vpsvc.com/".concat(locale, ".json"), {
                method: 'GET'
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                _context.next = 8;
                break;
              }
              logWarning(FAILED_TO_FETCH_POPULAR_SEARCHES, {
                contextData: {
                  locale: locale,
                  status: response.status,
                  statusText: response.statusText
                }
              });
              setPopularSearches([]);
              return _context.abrupt("return");
            case 8:
              _context.next = 10;
              return response.json();
            case 10:
              data = _context.sent;
              if (!(!data || !Array.isArray(data.popularSearches))) {
                _context.next = 15;
                break;
              }
              logWarning(INVALID_DATA_FORMAT, {
                contextData: {
                  locale: locale,
                  data: data
                }
              });
              setPopularSearches([]);
              return _context.abrupt("return");
            case 15:
              setPopularSearches(data === null || data === void 0 ? void 0 : data.popularSearches);
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              logWarning(FAILED_TO_FETCH_POPULAR_SEARCHES, {
                contextData: {
                  locale: locale,
                  error: _context.t0 instanceof Error ? _context.t0.message : String(_context.t0)
                }
              });
              setPopularSearches([]);
            case 22:
              _context.prev = 22;
              setIsPopularSearchesLoaded(true);
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 18, 22, 25]]);
      }));
      return function fetchPopularSearches(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    fetchPopularSearches(locale);
  }, [locale]);
  return {
    popularSearches: popularSearches,
    isPopularSearchesLoaded: isPopularSearchesLoaded
  };
};

export { usePopularSearches };
//# sourceMappingURL=usePopularSearches.js.map
